module.exports = __webpack_public_path__ + "static/img/Callum-Wilkie.18f59e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Callum-Wilkie.jpg
// module id = FX4r
// module chunks = 0